export default __webpack_public_path__ + "static/media/logonew.a5e216c7.png";